export var Language;
(function (Language) {
    Language["En_US"] = "en-US";
    Language["En_GB"] = "en-GB";
    Language["De_DE"] = "de-DE";
    Language["Fr_FR"] = "fr-FR";
    Language["It_IT"] = "it-IT";
    Language["Es_ES"] = "es-ES";
    Language["Nl_NL"] = "nl-NL";
    Language["Pl_PL"] = "pl-PL";
    Language["Unknown"] = "en-US";
})(Language || (Language = {}));
export var ProductType;
(function (ProductType) {
    ProductType[ProductType["Unknown"] = 0] = "Unknown";
    ProductType[ProductType["Remote"] = 1] = "Remote";
    ProductType[ProductType["BlindController"] = 2] = "BlindController";
    ProductType[ProductType["LightController"] = 3] = "LightController";
    ProductType[ProductType["HeatingController"] = 4] = "HeatingController";
    ProductType[ProductType["FacadeBlindController"] = 5] = "FacadeBlindController";
    ProductType[ProductType["GateController"] = 6] = "GateController";
    ProductType[ProductType["DoorController"] = 7] = "DoorController";
    ProductType[ProductType["GatewayController"] = 8] = "GatewayController";
    ProductType[ProductType["Sensor"] = 9] = "Sensor";
    ProductType[ProductType["SwitchController"] = 10] = "SwitchController";
    ProductType[ProductType["Meters"] = 11] = "Meters";
    ProductType[ProductType["Cameras"] = 12] = "Cameras";
    ProductType[ProductType["Intercoms"] = 13] = "Intercoms";
})(ProductType || (ProductType = {}));
export class SupportedDevice {
    constructor() {
        this.ModelGuid = "";
        /// <summary>
        /// Tells if the device requires a EFC-04 controller to work.
        /// </summary>
        this.RequiresController = false;
        /// <summary>
        /// The name of the device in the form of a map of key-value pairs. The key is the language code and the value is the name in that language.
        /// </summary>
        this.ModelName = "";
        /// <summary>
        /// The guid of manufacturer of the device.
        /// </summary>
        this.ManufacturerGuid = "";
        /// <summary>
        /// The name of the manufacturer of the device.
        /// </summary>
        this.ManufacturerName = "";
        /// <summary>
        /// The guid of the device's protocol.
        /// </summary>
        this.DeviceProtocolGuid = "";
        /// <summary>
        /// The name of the device's protocol.
        /// </summary>
        this.DeviceProtocolName = "";
        /// <summary>
        /// The list of the device's groups like ExtaLife, ExalusHome, etc.
        /// </summary>
        this.ProductGroups = [];
        this.ProductTypes = [];
        /// <summary>
        /// Device name
        /// </summary>
        this.Name = "";
        /// <summary>
        /// The description of the device
        /// </summary>
        this.Description = "";
        /// <summary>
        /// Promotional video.
        /// </summary>
        this.PromoVideo = null;
        /// <summary>
        /// The list of links to the pictures of the device.
        /// </summary>
        this.Pictures = [];
        /// <summary>
        /// Show on control grid as device demo.
        /// </summary>
        this.ShowAsDeviceDemo = false;
        /// <summary>
        /// The places where the device can be bought
        this.WhereToBuy = [];
        /// <summary>
        /// The list of links to the manuals and documents of the device.
        /// </summary>
        this.ManualsAndDocuments = [];
        /// <summary>
        /// The list of links to the videos for this device.
        /// </summary>
        this.Videos = [];
    }
}
export class ExternalSite {
    constructor() {
        this.Id = "";
        this.Name = "";
        this.Link = "";
    }
}
export class Video {
    constructor() {
        this.Id = "";
        this.Title = "";
        this.Link = "";
    }
}
export class ExternalDocument {
    constructor() {
        this.Id = "";
        this.Title = "";
        this.Link = "";
    }
}
//# sourceMappingURL=ISupportedDevicesService.js.map